module.exports = __webpack_public_path__ + "img/1920_leuco_intro_img4.337c386c.png";